<template>
    <div>
        <div class="btn-group w-100 mb-5" role="group">
            <button type="button"
                    @click="type = 1"
                    class="btn btn-lg"
                    :class="{'btn-primary': type === 1, 'btn-light-primary': type !== 1}">
                <i class="fas fa-ban"></i>
                <span class="d-none d-md-inline-block"> Ohne Geschäft</span>
            </button>
            <button type="button"
                    @click="type = 2"
                    class="btn btn-lg"
                    :class="{'btn-primary': type === 2, 'btn-light-primary': type !== 2}">
                <i class="fas fa-warehouse"></i>
                <span class="d-none d-md-inline-block"> Vorhandenes Geschäft</span>
            </button>
            <button type="button"
                    @click="type = 3; $emit('store_role', {id: 1, name: 'owner'})"
                    class="btn btn-lg"
                    :class="{'btn-primary': type === 3, 'btn-light-primary': type !== 3}">
                <i class="fas fa-plus-square"></i>
                <span class="d-none d-md-inline-block"> Neues Geschäft</span>
            </button>
        </div>
        <input v-if="type === 1"
               type="hidden"
               name="type"
               value="no_store"
        >
        <div v-if="type === 2" class="pt-5">
            <existing-store @input="store => $emit('input', store)"
                            @store_role_selected="(role) => $emit('store_role', role)"
            />
        </div>
        <div v-if="type === 3" class="pt-5">
            <p>
                Create store and then select it under "Vorhandenes Geschäft"
            </p>
            <div>
                <a :href="$route('admin.stores.create')" target="new" class="btn btn-outline-primary" @click="type = 2">
                    <i class="fas fa-arrow-circle-right mr-1" />
                    Create store
                </a>
            </div>
        </div>
    </div>
</template>

<script>
import CreateStore from './../CreateStore.vue'
import ExistingStore from './ExistingStore'

export default {
    components: {
        CreateStore,
        ExistingStore,
    },

    data() {
        return {
            type: 1,
        }
    },
}
</script>
